import React from "react";
import { cn } from "../../lib/utils";

export const Card = ({ className, ...props }) => (
  <div className={cn("rounded-xl border bg-white p-4 shadow", className)} {...props} />
);

export const CardContent = ({ className, ...props }) => (
  <div className={cn("p-4", className)} {...props} />
);
